export const auStates = [
	'Australian Capital Territory',
	'New South Wales',
	'Northern Territory',
	'Queensland',
	'South Australia',
	'Tasmania',
	'Victoria',
	'Western Australia',
];
